import { ForgotPassword } from '@unistocks/features/authentication/forgot-password';
import { t } from '@unistocks/shared/localization/index.ts';
import Head from 'expo-router/head';

export default function ForgotPasswordScreen() {
  return (
    <>
      <Head>
        <title>{`${t('AbpAccount::PasswordReset')} | Unistocks`}</title>
      </Head>
      <ForgotPassword />
    </>
  );
}
